import React, { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import Modal from '../../UIelements/Modal';
import PrimaryButton from '../../FormElements/PrimaryButton/index';
import * as Styled from './styles';
import { toast } from 'react-toastify';
import Loading from '../../Loading';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { deleteSerialNumbers } from '../../../services';

type ModalProps = {
  onCancel: () => void;
  refresh: () => void;
  selectSerialNumber: number[]
}

const ModalDeleteSerialNumber: FC<ModalProps> = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const intl = useIntl();
  const globalUser = useSelector((state: RootState) => state.user.object);

  const submitHandler = async () => {
    setIsLoading(true)
    try {
      await deleteSerialNumbers({ idSerialNumbers: props.selectSerialNumber }, globalUser?.user.accessToken ?? '',)
      toast.success(
        intl.formatMessage({ id: 'company.O equipamento foi removida com sucesso!' }).toUpperCase()
      );
    } catch (error) {
      console.error(error)
      toast.error(
        intl.formatMessage({ id: 'company.Não foi possível remover o equipamento' }).toUpperCase()
      );
    } finally {
      setIsLoading(false)
      props.onCancel()
      props.refresh()
    }
  }

  const footer = (
    <>
      <PrimaryButton type='button' size='buttonModal' model='confirmation-gradient-modal' width='68px' onClick={() => submitHandler()}>
        {intl.formatMessage({ id: 'menus.Sim' })}
      </PrimaryButton>
      <PrimaryButton type='button' size='buttonModal' model='cancellation' width='68px' onClick={props.onCancel}>
        {intl.formatMessage({ id: 'menus.Não' })}
      </PrimaryButton>
    </>
  )

  return (
    <Modal
      title={intl.formatMessage({ id: 'company.excluir equipamento' }).toUpperCase()}
      onCancel={props.onCancel}
      onSubmit={submitHandler}
      footer={!isLoading ? footer : undefined}
      width='500px'
    >
      {isLoading && <Loading />}
      {!isLoading && (
        <>
          <Styled.Text>{intl.formatMessage({ id: 'company.Você deseja excluir o equipamento selecionado definitivamente?' })}</Styled.Text>
          <Styled.Text2>
            {intl.formatMessage({ id: 'menus.Esta ação não poderá ser desfeita.' })}
          </Styled.Text2>
        </>
      )}

    </Modal>
  );
};

export default ModalDeleteSerialNumber;
